import React from 'react';
import { useSelector } from 'react-redux';
import { Column, Row, FlexBox, H1, H2, Count, Typography } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { cartSelectors } from '../../../state/cart';
import { cartItemSelectors } from '../../../state/cartItems';
import { RootState } from '../../../types';

export const CartMainHeading = () => {
  const [cartMessages] = useTranslations(['cartMessages']);

  const cToolsDown = useSelector((state: RootState) =>
    cartSelectors.selectIsCToolsOffline(state.cart)
  );

  const pendingItemsCount = useSelector((state: RootState) =>
    cartSelectors.selectPendingItemsCount(state.cart)
  );

  const cartItemDisplayGroupsCount = useSelector((state: RootState) =>
    cartItemSelectors.selectCartItemDisplayGroupsCount(state.cartItems)
  );

  return (
    <Row marginTop={4}>
      <Column span={12}>
        <FlexBox>
          <H1 fontSize={5} fontWeight="bolder">
            {cartMessages.titleMessage}
          </H1>
          <FlexBox>
            <H2>
              {cToolsDown && pendingItemsCount > 0 ? (
                <Count marginLeft={4} style={{ verticalAlign: 'middle' }}>
                  +{pendingItemsCount}
                </Count>
              ) : (
                <Count
                  skin="standard"
                  marginLeft={4}
                  style={{ verticalAlign: 'middle' }}
                  visuallyHidden={cToolsDown}
                >
                  {cartItemDisplayGroupsCount}
                </Count>
              )}
              <Typography component="span" visuallyHidden>
                {' '}
                items
              </Typography>
            </H2>
          </FlexBox>
        </FlexBox>
      </Column>
    </Row>
  );
};
